import React, { useState } from "react";
import {
  IconButton,
  VaporIcon,
  FormControl,
  InputAdornment,
  TextField,
} from "@vapor/v3-components";
import { faEye, faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import { SxProps } from "@mui/material";
import { Theme } from "@mui/system";

interface TextEyePasswordProps {
  id?: string;
  inputRef?: React.Ref<any>;
  value?: unknown;
  label?: React.ReactNode;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  sx?: SxProps<Theme>; // Consente di passare stili tramite la prop `sx`
  variant?: "filled" | "outlined" | "standard";
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  fullWidth?: boolean;
  autoFocus?: boolean;
  autoComplete?: string;
  error?: boolean;
  defaultValue?: unknown;
  messageType?: "error" | "success" | "informative";
  iconLabel?: React.ReactNode;
  helperText?: React.ReactNode;
  size?: "small" | "medium";
  style?: React.CSSProperties;
}

export const TextEyePassword: React.FC<TextEyePasswordProps> = ({
  id,
  inputRef,
  value,
  label,
  onChange,
  onKeyDown,
  sx,
  required,
  disabled,
  readOnly,
  fullWidth,
  autoFocus,
  autoComplete,
  error,
  defaultValue,
  messageType,
  iconLabel,
  helperText,
  size,
  style,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormControl>
      <TextField
        label={label}
        variant="outlined"
        id={id}
        inputRef={inputRef} // Riferimento per lo spostamento del focus
        type={showPassword ? "text" : "password"}
        sx={{ ...sx, flexShrink: 0 } as any}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        fullWidth={fullWidth}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        error={error}
        defaultValue={defaultValue}
        messageType={messageType}
        iconLabel={iconLabel}
        helperText={helperText}
        size={size}
        style={style}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ margin: 0, padding: 0 }}>
              <IconButton
                aria-label="toggle password visibility"
                onClick={(e) => setShowPassword(!showPassword)}
                edge="end"
                sx={{ padding: 0 }}
                variant="text"
              >
                {showPassword ? (
                  <VaporIcon icon={faEye} size="s" />
                ) : (
                  <VaporIcon icon={faEyeSlash} size="s" />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
};
